// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2369":"0f21b0d3","3165":"1cb1c82e","5405":"b5b79ce4","6723":"9f499143","6933":"05b68734"}[chunkId] + ".chunk.css";
};